import { yupResolver } from "@hookform/resolvers/yup";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router";

import { useAddOfferMutation } from "../../../../features/offers/offersApiSlice";
import ControlledTextField from "../../../controlled/ControlledTextField";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getFormSchema } from "./formSchema";

export const ActionButton = ({ disableFields, cargoId, currentOffer }) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [addOffer, { isLoading }] = useAddOfferMutation();

	const [searchParams] = useSearchParams();
	const token = searchParams.get("token");

	const formSchema = getFormSchema(t);
	const {
		handleSubmit,
		control,
		formState: { errors },
		setValue,
		setError,
	} = useForm({
		resolver: yupResolver(formSchema),
		shouldFocusError: true,
	});

	const handleAddOffer = async ({ price }) => {
		await addOffer({
			token,
			cargoId,
			price,
		})
			.unwrap()
			.then((_payload) => {
				enqueueSnackbar(t("sent_offer"), {
					variant: "success",
				});
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([key, message]) => {
						setError(key);
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	useEffect(() => {
		if (currentOffer) {
			setValue("price", currentOffer);
		} else {
			setValue("price", "");
		}
	}, [currentOffer, setValue]);

	useEffect(() => {
		if (Object.keys(errors).length > 0) {
			Object.values(errors).forEach((err) => {
				enqueueSnackbar(err.message, {
					variant: "error",
					preventDuplicate: true,
				});
			});
		}
	}, [errors, enqueueSnackbar]);

	return (
		<>
			<Box component="form" noValidate onSubmit={handleSubmit(handleAddOffer)}>
				<Box sx={{ alignItems: "center", display: "flex", gap: "4px" }}>
					<Box sx={{ alignItems: "center", display: "flex" }}>
						<ControlledTextField
							disabled={disableFields}
							control={control}
							margin="normal"
							name="price"
							label={t("price")}
							defaultValue={currentOffer ? currentOffer : ""}
							error={!!errors?.price}
							startAdornment={
								<InputAdornment position="start">€</InputAdornment>
							}
							sx={{ my: 0, minWidth: "92px" }}
						/>
					</Box>
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Button
							disabled={disableFields}
							loading={isLoading}
							type="submit"
							variant="contained"
							sx={{ boxShadow: 0, p: "2px 4px", minWidth: "58px" }}
						>
							{t("send")}
						</Button>
					</Box>
				</Box>
			</Box>
		</>
	);
};
